import React from "react";
import "../styles/hosting-panels.css"; // Matches /src/styles/hosting-panels.css

export default function HostingPanelBlocks() {
  return (
    <section className="panels-blocks-wrapper">
      
      {/* === PLESK BLOCK (Text Left / Image Right) === */}
      <div className="panel-block">
        <div className="block-text">
          <h2>Enterprise-Grade Wordpress Hosting with OpenLiteSpeed &amp; Ubuntu 24.04</h2>
          <p>
            <strong>OpenLiteSpeed</strong> is the Open Source edition of LiteSpeed Web Server Enterprise and contains all of the essential features, including HTTP/3 support. OLS provides enormous scalability and an accelerated hosting platform for WordPress and is exponentially faster than both Nginx and Apache. Ubuntu 24.04 with OpenLiteSpeed is provided wtih: PHP, MySQL Server, WordPress, LiteSpeed Cache, and other useful applications for the fastest running Wordpress to date.
          </p>
          <ul>
            <li>One-click deployment and four easy steps to get rolling.</li>
            <li>WordPress 6.8.1</li>
            <li>OpenliteSpeed 1.8.3</li>
            <li>MariaDB	11.4</li>
            <li>PHP	8.3</li>
            <li>CertBot	Latest.</li>
            <li>phpMyAdmin Latest</li>
            <li>Memcached Latest</li>
            <li>Redis Latest</li>
          </ul>
        </div>
        <div className="block-image">
          <img src="/images/olsw.png" alt="Plesk Hosting" />
        </div>
      </div>

      {/* === cPanel BLOCK (Image Left / Text Right) === */}
      <div className="panel-block">
        <div className="block-image">
          <img src="/images/cpanel.png" alt="cPanel Hosting" />
        </div>
        <div className="block-text">
          <h2>Advanced Enterprise-Grade Hosting Management with cPanel &amp; Linux</h2>
          <p>
            <strong>cPanel</strong> is the world’s most popular Linux-based web hosting control panel, offering a clean, intuitive interface for managing websites, domains, email, and databases. Designed for reliability and performance, cPanel is trusted by web hosts and site owners worldwide to simplify administration and enhance security.
          </p>
          <ul>
            <li>User-friendly dashboard for managing sites, domains, and mail</li>
            <li>Automated backups, SSL, and software updates</li>
            <li>One-click installers for WordPress, Joomla, and more</li>
            <li>Built-in tools for file, database, and DNS management</li>
            <li>Proven stability and security for any size website or business.</li>
            <li>Webmail 10/10 at mail-tester.com and will deploy to any inbox.</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
